import { render, staticRenderFns } from "./MobileUpload.vue?vue&type=template&id=4a45ab47&scoped=true"
import script from "./MobileUpload.vue?vue&type=script&lang=js"
export * from "./MobileUpload.vue?vue&type=script&lang=js"
import style0 from "./MobileUpload.vue?vue&type=style&index=0&id=4a45ab47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45ab47",
  null
  
)

export default component.exports